import service from '@/store/services/employers/works-service';

const state = {
    list: {},
    work: {},
    meta: {}
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, work) => {
        state.work = work;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(work => {
                commit('SET_RESOURCE', work);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(work => {
                commit('SET_RESOURCE', work);
            });
    },
    add ({ commit }, params) {
        return service.add(params)
            .then((work) => {
                console.log(work);

                commit('SET_RESOURCE', work);

                return work;
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((work) => {
                commit('SET_RESOURCE', work);
                return work;
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    work: state => state.work,
    dropdown: (state) => {
        return state.list.map(work => ({
            id: work.id,
            name: work.name
        }));
    }
};

const works = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default works;
